'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fontSizeMixin = fontSizeMixin;
exports.textTruncate = textTruncate;
exports.textKerning = textKerning;

var _type = require('../settings/type');

// Font Size mixin
// -----------------------------------------------------------------------------
// This is the mixin you will be using to define your font-size in all of your
// components.
//
// Using this mixin ties the font-size to your line-height scale, for consistent
// typography throughout your project.
// -----------------------------------------------------------------------------
function fontSizeMixin(fontSizeValue) {
    var lineHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : fontSizeValue;

    return '\n   font-size: ' + (0, _type.fontSize)(fontSizeValue) + ';\n   line-height: ' + lineHeight(fontSizeValue) + ';\n  ';
}
// Text Truncate
// -----------------------------------------------------------------------------
// 1. Ensure that the node has a maximum width after which truncation can occur.
// 2. Fix for IE 8/9 if `word-wrap: break-word` is in effect on ancestor nodes.
// -----------------------------------------------------------------------------
// =============================================================================
// TYPOGRAPHY (Tools)
// =============================================================================
function textTruncate() {
    return '\n    max-width: 100%; // 1\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    word-wrap: normal; // 2\n  ';
}
// Text Kerning
// -----------------------------------------------------------------------------
// 1. Chrome (not Windows), Firefox, IE 10+.
// 2. Safari 7 and future browsers.
// 3. Chrome (not Windows), Firefox, Safari 6+, iOS, Android.
// -----------------------------------------------------------------------------
function textKerning() {
    return '\n    font-feature-settings: \'kern\' 1; // 1\n    font-kerning: normal; // 2\n    text-rendering: optimizeLegibility; // 3\n  ';
}
//# sourceMappingURL=type.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/toolkit/tools/type.js